// removed by extract-text-webpack-plugin
module.exports = {"FAQSearchInput":"_11OUSJfjbHqydMati4T5Tt","FAQSearch":"_2_lG-8lTAWXbbDxfz83ana","FAQAdd":"_6OAuMjY5nYTAIz4a-DMru","FAQList":"_1xm6_3On8kpu_gjfhj0IUf","FAQItemTitle":"J3ITLE54QnwvSyaVaOYyp","FAQItemAnswer":"x605a86VSVKM5y3Xo_Bnf","FAQItemButton":"_18TdOxtIZMPj2vfHGbxNTi","FAQItemQuestionTextArea":"_3mJ_fsaRhyutSRcOzn2nPq","SVGButton":"_2bmz6hoYV7eu0dhm9OQIOJ"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/ChatSettings/QuickResponse/Item/Item.css
// module id = 853
// module chunks = 0